import React from 'react';
import { Badge } from '@ygtechnologies/rubus-ui';

export const AwaitingSignaturesPill = ({
    awaitingSignatures,
    color,
}: {
    awaitingSignatures: number;
    color: 'success' | 'warning' | 'info' | 'danger';
}) => {
    return (
        <Badge variant={color} appearance="subtle">
            {awaitingSignatures}
        </Badge>
    );
};
